<!-- eslint-disable no-unused-vars -->
<template>
  <div>
   <div v-if="notHavePayment">
     <v-dialog v-model="dialogUploadpayment" >
     <v-card>
       <v-toolbar
         dark
         :color="$bgColor2"
       >
         <v-toolbar-title>{{ $t("message.uploadPayment") }}</v-toolbar-title>
         <v-spacer></v-spacer>
         <v-toolbar-items>
           <v-btn
           icon
           dark
           @click="dialogUploadpayment = false, pictureUrlPreview = '', filesAdd = null"
         >
           <v-icon>mdi-close</v-icon>
         </v-btn>
         </v-toolbar-items>
       </v-toolbar>
       <div class="pa-5">
         <v-card min-height="500" class="pa-5">
           <v-file-input
             label="upload payment"
             outlined
             dense
             accept="image/png, image/jpeg, image/bmp"
             v-model="filesAdd"
             @change="selectImg"
           ></v-file-input>
           <!-- <v-img
                 src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FQR-prompt.jpg?alt=media&token=42637b63-af5b-45d9-8900-b866b789819e"
               />
           <qrcode-vue class="mt-3" :value="valuePromtpay" level="H" :size="220" :foreground="foreground" style="display:flex;justify-content:center;"/>
           <p class="mt-6" style="">บัญชี: {{accountName}}</p> -->
           <!-- <div>

           </div> -->
           <div v-if="pictureUrlPreview === null || pictureUrlPreview === ''" style="height: 300px;
             display: flex;
             align-items: center;
             justify-content: center;">
             <v-icon style="font-size:50px">mdi-note-text-outline</v-icon>
           </div>
           <v-img
             v-if="pictureUrlPreview"
             contain
             :src="pictureUrlPreview"
           ></v-img>
           <div style="text-align: center;">
             <v-btn class="mt-3" color="#28a745" :disabled="!pictureUrlPreview" v-if="!pictureUrlPreview">{{ $t("message.save") }} <v-icon class="ml-2">mdi-cloud-upload</v-icon></v-btn>
             <v-btn class="mt-3" color="#28a745" v-if="pictureUrlPreview" :loading="loaded" dark @click="savePayment()">{{ $t("message.save") }} <v-icon class="ml-2">mdi-cloud-upload</v-icon></v-btn>
           </div>
         </v-card>
       </div>
     </v-card>
   </v-dialog>
   <!-- dialog บัญชี -->
    <v-dialog v-model="dialog" fullscreen>
     <v-card>
       <v-toolbar
         dark
         :color="$bgColor2"
       >
         <v-toolbar-title>{{ $t("message.accountBank") }}</v-toolbar-title>
         <v-spacer></v-spacer>
         <v-toolbar-items>
           <v-btn
           icon
           dark
           @click="dialog = false"
         >
           <v-icon>mdi-close</v-icon>
         </v-btn>
         </v-toolbar-items>
       </v-toolbar>
       <div class="pa-5" v-if="payType === 'promptpay'">
         <v-card min-height="500">
           <v-img
                 src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FQR-prompt.jpg?alt=media&token=42637b63-af5b-45d9-8900-b866b789819e"
               />
           <qrcode-vue class="mt-3" :value="valuePromtpay" level="H" :size="220" :foreground="foreground" style="display:flex;justify-content:center;"/>
           <p class="mt-6" style="text-align: center;">{{ $t("message.accountBank") }}: {{accountName}}</p>
           <p class="mb-0" style="text-align: center;">{{ $t("message.privileges") }}: {{packageData.packageName}}</p>
           <p class="mb-0" style="text-align: center;">{{ $t("message.amount") }}: {{formatNumber(packageData.packagePrice)}} บาท</p>
         </v-card>
       </div>
       <v-img
         v-if="payType === 'bank'"
         :src="pictureBank"
       />
       <div style="display:flex;justify-content: center;">
           <p style="color:red" class="mb-0">**</p>
           <p class="mb-0">({{ $t("message.afterUpload") }})</p>
       </div>
       <div class="mt-4 mb-4" style="text-align: center;">
         <v-btn color="#6892C1" :disabled="statusCheckReward" dark @click="uploadPayment()">{{ $t("message.uploadPayment") }}<v-icon>mdi-arrow-right</v-icon></v-btn>
       </div>
     </v-card>
   </v-dialog>
    <div>
      <v-img :src="shopData.logo" style="max-height:150px">
      </v-img>
    </div>
    <v-container>
       <div class="mt-0" style="text-align: center;font-size: 22px;color: #32324D;font-weight: bold;">
         {{ $t("message.selectPayment") }}
       </div>
       <!-- <div class="mt-3" style="text-align: center;font-size: 16px;color: #8E8EA9;">
       </div> -->
       <div style="text-align: center;font-size: 20px;color: rgb(11 11 12);">
         <p class="mb-0">{{ $t("message.privileges") }}: {{packageData.packageName}}</p>
         <p class="mb-0">{{ $t("message.paymentTotal") }}: {{formatNumber(packageData.packagePrice)}} บาท</p>
       </div>
       <div style="display:flex;justify-content: center;">
         <p style="color:red" class="mb-0">**</p>
         <p class="mb-0">({{ $t("message.afterUpload") }})</p>
     </div>
     <div class="mt-4 mb-2" style="text-align: center;">
       <v-btn color="#6892C1" style="color: white !important" :disabled="statusCheckReward" @click="uploadPayment()">{{ $t("message.uploadPayment") }}<v-icon>mdi-arrow-right</v-icon></v-btn>
     </div>
       <div class="mt-2" v-if="payType === 'bank'">
         <v-slide-group active-class="success" v-if="paymentItem.length > 1">
           <v-slide-item v-for="(item, i) in paymentItem" :key="i">
             <v-card
               style="border-radius: 20px"
               class="ma-2 pa-1 mt-4"
               width="200"
               elevation="2"
               max-height="370"
               min-height="370"
               @click="downloadImage(item.payImage, 'bank')"
             >
               <v-img
                 ref="image"
                 :src="item.payImage"
               />
               <div class="mt-3" style="text-align: center;">{{ $t("message.accountBank") }}: {{item.promtpayName}}</div>
             </v-card>
           </v-slide-item>
         </v-slide-group>
         <div active-class="success" v-if="paymentItem.length === 1" style="display: flex;justify-content: center;">
             <v-card
               style="border-radius: 20px"
               class="ma-2 pa-1 mt-4"
               width="200"
               elevation="2"
               max-height="370"
               min-height="400"
               @click="downloadImage(paymentItem[0].payImage, 'bank')"
             >
               <v-img
                 ref="image"
                 :src="paymentItem[0].payImage"
               />
               <div class="mt-3" style="text-align: center;">{{ $t("message.accountBank") }}: {{paymentItem[0].promtpayName}}</div>
             </v-card>
         </div>
       </div>
       <div class="mt-2" v-if="payType === 'promptpay'">
         <v-slide-group active-class="success" v-if="paymentItem.length > 1">
           <v-slide-item v-for="(item, i) in paymentItem" :key="i">
             <v-card
               style="border-radius: 20px"
               class="ma-2 pa-1 mt-4"
               width="200"
               elevation="2"
               max-height="370"
               min-height="370"
               @click="downloadImage(item.valueQrcodePromtpay, 'promtpay', item.promtpayName)"
             >
               <v-img
                 src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FQR-prompt.jpg?alt=media&token=42637b63-af5b-45d9-8900-b866b789819e"
               />
               <qrcode-vue class="mt-3" :value="item.valueQrcodePromtpay" level="H" :size="180" :foreground="foreground" style="display:flex;justify-content:center;"/>
               <div class="mt-3" style="text-align: center;">{{ $t("message.accountBank") }}: {{item.promtpayName}}</div>
             </v-card>
           </v-slide-item>
         </v-slide-group>
         <div active-class="success" v-if="paymentItem.length === 1" style="display: flex;justify-content: center;">
             <v-card
               style="border-radius: 20px"
               class="ma-2 pa-1 mt-4"
               width="200"
               elevation="2"
               max-height="370"
               min-height="370"
               @click="downloadImage(paymentItem[0].valueQrcodePromtpay, 'promtpay', paymentItem[0].promtpayName)"
             >
               <v-img
                 src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FQR-prompt.jpg?alt=media&token=42637b63-af5b-45d9-8900-b866b789819e"
               />
               <!-- <v-img
                 ref="image"
                 :src="paymentItem[0].payImage"
               /> -->
               <qrcode-vue class="mt-3" :value="paymentItem[0].valueQrcodePromtpay" level="H" :size="180" :foreground="foreground" style="display:flex;justify-content:center;"/>
               <div class="mt-3" style="text-align: center;">{{ $t("message.accountBank") }}: {{paymentItem[0].promtpayName}}</div>
             </v-card>
         </div>
       </div>
    </v-container>
    <!-- <div style="display:flex;justify-content: center;">
       <p style="color:red" class="mb-0">**</p>
       <p class="mb-0">({{ $t("message.afterUpload") }})</p>
    </div>
    <div class="mt-4 mb-4" style="text-align: center;">
      <v-btn color="#6892C1" dark @click="uploadPayment()">{{ $t("message.uploadPayment") }}<v-icon>mdi-arrow-right</v-icon></v-btn>
    </div> -->
   </div>
   <div v-if="!notHavePayment" style="display: flex;justify-content:center;align-items:center;height: 80vh;">
     no data payment
   </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'// import Swal from 'sweetalert2'
import axios from 'axios'
import Swal from 'sweetalert2'
export default {
  name: 'PointCollect',
  components: {
    QrcodeVue
  },
  data () {
    return {
      shopId: this.$session.get('shopId'),
      id: this.$route.params.id,
      paymentItem: null,
      shopData: null,
      picPayment: null,
      dialog: null,
      dialogUploadpayment: false,
      pictureBank: null,
      payType: null,
      packageData: null,
      foreground: '#000000',
      valuePromtpay: null,
      accountName: null,
      filesAdd: null,
      pictureUrlPreview: null,
      createQRcodePackage: {
        packageId: '',
        status: 'waiting',
        CREATE_USER: '',
        liffId: '',
        memberId: '',
        LAST_USER: '',
        shopId: '',
        CREATE_DATE: '',
        chkQRCode: 1
      },
      pictureUrl: null,
      loaded: false,
      branchData: [],
      notHavePayment: false,
      statusCheckReward: false,
      listRewardCount: null
      // success: false,
      // levelup: false,
      // failed: false,
      // packageToken: null,
      // point: null,
      // message: null,
      // level: null,
      // member: null,
      // levelUpdate: null,
      // findUser: null,
      // profile: [],
      // detailPackage: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.packageId = this.$route.query.packageToken

    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getDatapackage()
    await this.checkTypepayment()
    await this.getBranch()
    // await this.checkliff()
    if (this.shopId === 'SD_1737957295593') {
      let res = await axios.get(this.DNS_IP + `/reward-check-outofStock?packageId=${this.id}`)
      if (this.packageData.listReward && this.packageData.listReward !== ' ' && this.packageData.listReward !== '') {
        this.listRewardCount = JSON.parse(this.packageData.listReward).length
      }
      if (Array.isArray(res.data)) {
        if (res.data.length !== this.listRewardCount) {
          this.statusCheckReward = true
          alert('ไม่สามารถซื้อแพ็กเกจได้\nเนื่องจากของรางวัลในแพ็กเกจไม่ครบกรุณาติดต่อเจ้าหน้าที่')
        }
      } else {
        this.statusCheckReward = true
      }
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    async checkTypepayment () {
      try {
        let res = await axios.get(this.DNS_IP + '/system_shop/get?shopId=' + this.shopId)
        this.shopData = res.data[0]
        if (res.data[0].showPromtPay.toLowerCase() === 'false') {
          let data = await axios.get(this.DNS_IP + '/Payment/get?shopId=' + this.shopId + '&payType=bank')
          if (Array.isArray(data.data)) {
            this.notHavePayment = true
            this.paymentItem = data.data
            const packagedData = this.packageData.packageId
            // เช็คว่า packagedData มีค่าหรือไม่
            if (packagedData) {
              this.paymentItem = this.paymentItem.filter(item => {
                if (!item.listPackageId || item.listPackageId === '') {
                  return item // ถ้าเป็น null หรือ undefined ไม่ต้องแยก และกรองออกจากรายการ
                }
                const packageList = item.listPackageId.split(',')
                // กรองเฉพาะรายการที่มี packagedData อยู่ใน packageList
                return packageList.length === 1 ? packageList[0] === String(packagedData) : packageList.length > 0 ? packageList.find(item2 => item2 === String(packagedData)) : null // กรณีมีหลายข้อมูล
              })
            }
            this.payType = data.data[0].payType
          }
        } else {
          let data = await axios.get(this.DNS_IP + '/Payment/get?shopId=' + this.shopId + '&payType=promptpay')
          if (Array.isArray(data.data)) {
            this.notHavePayment = true
            this.paymentItem = data.data
            const packagedData = this.packageData.packageId
            // เช็คว่า packagedData มีค่าหรือไม่
            if (packagedData) {
              this.paymentItem = this.paymentItem.filter(item => {
                if (!item.listPackageId || item.listPackageId === '') {
                  return item // ถ้าเป็น null หรือ undefined ไม่ต้องแยก และกรองออกจากรายการ
                }
                const packageList = item.listPackageId.split(',')
                // กรองเฉพาะรายการที่มี packagedData อยู่ใน packageList
                return packageList.length === 1 ? packageList[0] === String(packagedData) : packageList.length > 0 ? packageList.find(item2 => item2 === String(packagedData)) : null // กรณีมีหลายข้อมูล
              })
            }
            this.payType = data.data[0].payType
            this.genQrCode()
          }
        }
      } catch (error) {
        console.error('cath', error)
      }
    },
    downloadImage (a, b, c) {
      if (b === 'bank') {
        this.dialog = true
        this.pictureBank = a
      } else {
        this.dialog = true
        this.valuePromtpay = a
        this.accountName = c
      }
    },
    selectImg () {
      if (this.filesAdd) {
        this.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    async collectPackage () {
      // get package by token
      const resultPackage = await this.callBeTaskAPI('get', `/packageQRcode/get?shopId=${this.$route.query.shopId}&token=${this.packageToken}`)
      if (resultPackage) {
        this.detailPackage = resultPackage[0]
      }
      const params = {
        'token': this.packageToken
      }
      // get collect package
      const result = await this.callBeTaskAPI('post', `/collect_package/edit`, params)
      if (result) {
        if (result.status === true) {
          this.success = true
        } else if (result.status === false) {
          this.success = false
          this.levelup = false
          this.failed = true
          // this.message = `${this.$t('message.sorry')}!<br>${this.$t('message.alreadyUsePackage')}`
        }
      }
    },
    async updateMember () {
      const result = await this.callBeTaskAPI('get', '/memberCard/line/get')
      if (result) {
        if (result.length > 0) {
          this.setMemberInfo(result[0])
        }
      }
    },
    async genQrCode () {
      this.paymentItem.map((item) => {
        const generatePayload = require('promptpay-qr')
        let amount = parseInt(this.packageData.packagePrice)
        item.valueQrcodePromtpay = generatePayload(item.promtpayNumber, { amount })
      })
      // const promptpayID = this.DataFlow[0].promptPayID
      // if (this.redirectBy === 'BookingAdmin') {
      //   this.value = generatePayload(promptpayID, { amount })
      //   console.log('typeof', typeof this.value)
      //   console.log('typeof', this.value)
      // }
    },
    uploadPayment () {
      this.dialogUploadpayment = true
    },
    async savePayment () {
      Swal.fire({
        title: `${this.$t('message.wantToupLoadPayment')}`,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then(async (confirm) => {
        if (confirm.isConfirmed) {
          this.loaded = true
          // eslint-disable-next-line no-unused-vars
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)


          this.createQRcodePackage.packageId = this.id
          this.createQRcodePackage.memberId = this.profile.memberId
          this.createQRcodePackage.CREATE_USER = this.profile.userId
          this.createQRcodePackage.LAST_USER = this.profile.userId
          this.createQRcodePackage.liffId = this.$liffId
          this.createQRcodePackage.shopId = this.shopId
          this.createQRcodePackage.masBranchID = ''
          if (this.branchData.length === 1) {
            this.createQRcodePackage.masBranchID = this.branchData[0].masBranchID
          }

          await axios
            .post(this.DNS_IP + `/file/upload/package`, params)
            .then((response) => {
              this.pictureUrl = response.data // `this` ใช้ได้โดยตรง
            })
            .catch((error) => {
              console.error(error)
            })
          await axios
            .post(this.DNS_IP + '/packageQRcode/add', this.createQRcodePackage)
            .then(async response => {
              // console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              const paramsCollectPackage = {
                'token': response.data.token,
                'typeBuy': 'payment',
                'paymentPicUrl': this.pictureUrl
              }
              let config = {
                headers: {
                  shopId: this.shopId,
                  lineId: this.profile.userId,
                  memberId: this.profile.memberId
                }
              }
              await axios
                .post(
                  this.DNS_IP +
               '/collect_package/edit',
                  paramsCollectPackage, config
                )
                .then(response => {
                  this.loaded = false
                  Swal.fire({
                    title: `${this.$t('message.complete')}`,
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#b3b1ab',
                    confirmButtonText: `${this.$t('message.confirm')}`
                  }).then((confirm) => {
                    if (confirm.isConfirmed) {
                      if (this.$isTargetShop()) {
                        this.$router.push('/MyPackage')
                      } else {
                        this.$router.push('/C/MyPackage')
                      }
                    }
                  })
                  // console.log('res', res)
                  // console.log('assign', this.veiwQRCode)
                })
              // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // this.loadingAdd = false
            })
            .catch(error => {
              console.error('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        }
      })
    },
    // async checkPayment () {
    //   let data = await axios.get('https://api-belinked.betaskthai.tech/sys_shop/get?shopId=' + this.shopId)
    //   console.log('data', data.data)
    //   if (data.data.showQrPayments === ('True')) {
    //     await axios.get('https://api-belinked.betaskthai.tech/master_payment/get?shopId=' + this.shopId).then(response => {
    //       let rs = response.data
    //       console.log('checkPayment', rs)
    //     })
    //   }
    // },
    async getDatapackage () {
      let res = await axios.get(this.DNS_IP + '/package/get?packageId=' + this.id)
      this.packageData = res.data[0]
    },
    async getBranch () {
      let res = await axios.get(this.DNS_IP + '/master_branch/get?shopId=' + this.shopId)
      this.branchData = res.data
    },
    async checkliff () {
      const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=${this.shopId}`)
      if (Array.isArray(result.data)) {
        // alert('find')
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.$liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      } else {
        this.$liffId = '1656906322-JN5MM8Ep'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Package/BuyPackage.vue